import * as React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { instance } from '@lib/index';
import {
  DiffStates,
  FrameMapping,
  Attribute,
  FrameItem,
  CompositeInfo,
  ReferenceNode,
  FrameMappingUpdateFuncArgumentConfig
} from '@interface/index';
import { FrameMappingModal } from './frame-mapping-modal';
import { NiTable } from '@component/index';
import { localizedString } from '@locale/index';

export interface FrameMappingTableProps {
  title: string;
  frame: FrameItem;
  availableComposites: CompositeInfo[];
  disabled?: boolean;
  tag: string;
  data: FrameMapping[];
  selectedParameters: Attribute[];
  onChange: (args: FrameMappingUpdateFuncArgumentConfig) => void;
}
export interface FrameMappingTableState {
  visible: boolean;
  cur: number;
  isNew: boolean;
}

export class FrameMappingTableComp extends React.Component<
  FrameMappingTableProps,
  FrameMappingTableState
> {
  public state: FrameMappingTableState = {
    visible: false,
    cur: -1,
    isNew: false
  };

  componentDidMount() {
    instance.on(`@addFrameMapping${this.props.tag}`, (args: any) => {
      this.setState({
        cur: 0,
        visible: true,
        isNew: args && args.isNew
      });
    });
  }
  componentWillUnmount() {
    instance.off(`@addFrameMapping${this.props.tag}`);
  }

  render() {
    const state = this.state;
    const props = this.props;
    const {
      title,
      frame,
      disabled = false,
      data,
      availableComposites
    } = this.props;

    return (
      <>
        {this.state.cur !== -1 && state.visible && (
          <FrameMappingModal
            disabled={disabled}
            title={title}
            frame={frame}
            availableComposites={availableComposites}
            data={data[state.cur]}
            visible={state.visible}
            confirm={this.handleConfirm}
            selectedParameters={props.selectedParameters}
            close={this.handleClose}
          />
        )}
        <NiTable
          className="db-table"
          rowKey={(record: FrameMapping) => record.id || ''}
          dataSource={this.props.data}
          columns={this.getColumns()}
          onRow={(record: FrameMapping, index?: number) => {

            return {
              onClick: () => {

                if (
                  record.state !== DiffStates.DEL &&
                  record.state !== DiffStates.MASTER_CONFLICT
                ) {
                  this.setState({
                    cur: index || 0,
                    visible: true,
                    isNew: false
                  });
                }
              }
            };
          }}
          pagination={false}
        />
      </>
    );
  }

  getColumns = () => {
    const props = this.props;

    const targetFrameColumn = {
      width: '90%',
      title: localizedString('frame_mapping_target_frame'),
      dataIndex: 'targetFrame',
      render: (node: ReferenceNode | undefined, record: FrameMapping, index: number) => {

        return (
          <div className="table-name-area text">
            <span>{node && node.name}</span>
          </div>
        );
      }
    };


    const sourceColumn = {
      width: '10%',
      title: 'Source',
      dataIndex: 'inheritedFromCompositeName',
      render: (name: string, record: FrameMapping, index: number) => {
        return name ? name : (record.isOverwrite ? 'Local+' : 'Local');
      }
    };

    const adminColumn = {
      title: '',
      className: 'hide',
      dataIndex: 'admin',
      width: 50,
      render: (admin: any, record: FrameMapping, index: number) => {
        return (
          <div className="icon-area">
            {
              !props.disabled &&
              !record.originKey &&
              !record.inheritedFromCompositeId &&
              (
                <DeleteOutlined
                  className="delete-icon"
                  onClick={async (e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation();

                    const realIndex = props.data.indexOf(record);
                    props.data.splice(realIndex, 1);

                    props.onChange({
                      nextFrameMappings: props.data,
                      nextDelFrameMapping: record
                    });
                  }} />
              )}
          </div>
        );
      }
    };

    return [
      targetFrameColumn,
      sourceColumn,
      adminColumn
    ];
  };

  handleConfirm = (next: any) => {
    const state = this.state;
    const props = this.props;
    next.dirty = true;
    this.props.data[state.cur] = next;
    this.props.onChange({
      nextFrameMappings: props.data
    });
    this.setState({
      visible: false,
      cur: -1
    });
  };

  handleClose = () => {
    const state = this.state;
    const props = this.props;

    if (state.isNew) {
      props.data.splice(this.state.cur, 1);
    }

    this.setState({
      visible: false,
      cur: -1
    });
  };
}
